import { identifyDatadogUser, logDatadogError } from '../../utils/datadog';
import type { ObservabilityContext, ObservabilitySink, ObservabilityUser } from '../types';

/**
 * Datadog RUM observability sink. Delegates to the raw vendor boundary in
 * `utils/datadog` (which owns init and the ignored-errors filter). This is the
 * only place the observability facade knows about Datadog.
 */
export function createDatadogSink(): ObservabilitySink {
  return {
    name: 'DATADOG',

    identifyUser(user: ObservabilityUser) {
      if (user.kind === 'CANDIDATE') {
        if (!user.orgId || !user.orgName) {
          return;
        }
        identifyDatadogUser({
          type: 'candidate',
          id: user.email,
          // Using email here because we don't have a user name from candidate auth.
          name: user.email,
          email: user.email,
          org_id: user.orgId,
          org_name: user.orgName,
        });
        return;
      }

      if (!user.userId || !user.orgId || !user.orgName) {
        return;
      }
      identifyDatadogUser({
        type: 'employee',
        // Employee record doesn't always exist before onboarding the directory;
        // fall back to the user email as an obvious differentiator.
        id: user.employeeId || user.userEmail || '',
        name: user.employeeName || user.userName || '',
        email: user.employeeEmail || user.userEmail || '',
        org_id: user.orgId,
        org_name: user.orgName,
      });
    },

    reportError(cause: unknown, context?: ObservabilityContext) {
      logDatadogError(cause, context);
    },

    reportMessage() {
      // Datadog RUM has no first-class message channel in our wrapper; diagnostic
      // messages are handled by other sinks (e.g. LogRocket).
    },
  };
}
